module.exports = __webpack_public_path__ + "static/img/arrow_right_hov.83ab4b2f.svg";